import React, { useEffect, useState } from 'react'
import user from '../../../../assets/images/leaderboard/user.svg'
import cup from '../../../../assets/images/leaderboard/cup.svg'
import wheat from '../../../../assets/images/leaderboard/no.1.svg'
import rank1 from '../../../../assets/images/leaderboard/rank1.svg'
import rank2 from '../../../../assets/images/leaderboard/rank2.svg'
import rank3 from '../../../../assets/images/leaderboard/rank3.svg'
import Select from 'react-select'
import NoLeaderboard from '../../NoData/NoLeaderboard'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import axios from 'axios'


const Leaderboard = () => {
    const configData = useSelector((state) => state.configSlice);
    const userData = useSelector(state => state.userSlice);
    let params = useParams()
    const moduleUUID = params.uuid;
    let MODE = configData.config.MODE;
    const [leaderBoardList, setLeaderBoardList] = useState([]);

    const getLeaderBoardList = async () => {
        try {

            const { data } = await axios.get(`${configData.config.API_URL}/api/analytics/leaderboard/${userData.user.group.uuid}/${moduleUUID}`, {
                headers: {
                    Authorization: `Bearer ${userData.token}`,
                    "Content-Type": "application/json"
                }
            });
            let list = data.data;
            const userIndex = list.findIndex(item => item.uuid === userData.user.uuid);
            if(userIndex !== -1 && list[userIndex].rank > 10 ){
                const userObject = list.splice(userIndex, 1)[0];
                list.splice(3, 0, userObject);
               }
            setLeaderBoardList(list);
        } catch (error) {
            console.log(error);
        }
    }

    useEffect(()=>{
        if(moduleUUID.length > 0 && MODE === "XR"){
          getLeaderBoardList();
        }
    },[moduleUUID])


    return (
        <>
        <div className="container">
            <div className='leaderboard-main'>
                {leaderBoardList.length > 0 ?
                   <div className="row">
                    <div className="col-12 ">
                        <div className="leaderboard my-2">
                           
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="toprank">
                                            <div className="topranfgtcfer p-3">
                                                <div className="row align-items-end">
                                                    <div className="col-md-4">
                                                        {leaderBoardList[1] ?
                                                            <div className="topleader stleader rank1">
                                                                { leaderBoardList[1].avatar ? 
                                                                <img className="mauserlead" src={leaderBoardList[1].avatar} alt="" referrerPolicy={'no-referrer'} /> 
                                                                :
                                                                <span className='mauserlead letters'>
                                                                    {leaderBoardList[1].name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                                                    </span>
                                                                 }
                                                                <div>
                                                                    <p className="rank"><img src={rank2} alt="" /> </p>
                                                                    <p className='name'>{leaderBoardList[1].name}</p>
                                                                    <p className='email'> {leaderBoardList[1].email ?? leaderBoardList[1].uid}</p>
                                                                    <hr />
                                                                    <p className='gname'>{leaderBoardList[1].group}</p>
                                                                    <p className='errors'><span>Errors : {leaderBoardList[0].averageErrors.all} </span> <span className='ps-3'>Time: {leaderBoardList[0].averageTime.all.average.humanReadable} </span></p>
                                                                </div>
                                                            </div>
                                                            : null}

                                                    </div>

                                                    <div className="col-md-4">
                                                        {leaderBoardList[0] ?
                                                            <div className="topleader stleader rank2">
                                                                { leaderBoardList[0].avatar ? 
                                                                <img className="mauserlead" src={leaderBoardList[0].avatar} alt="" referrerPolicy={'no-referrer'} />
                                                                :
                                                                <span className='mauserlead letters'>
                                                                    {leaderBoardList[0].name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                                                </span>
                                                                }
                                                                <img src={wheat} className='nuone' alt="" />
                                                                <div>
                                                                    <p className="rank"><img src={rank1} alt="" /></p>
                                                                    <p className='name'>{leaderBoardList[0].name}</p>
                                                                    <p className='email'> {leaderBoardList[0].email ?? leaderBoardList[0].uid}</p>
                                                                    <hr />
                                                                    <p className='gname'>{leaderBoardList[0].group}</p>
                                                                    <p className='errors'><span>Errors : {leaderBoardList[0].averageErrors.all} </span> <span className='ps-3'>Time: {leaderBoardList[0].averageTime.all.average.humanReadable} </span></p>
                                                                </div>
                                                            </div>
                                                            : null}
                                                    </div>

                                                    <div className="col-md-4">
                                                        {leaderBoardList[2] ?
                                                            <div className="topleader stleader rank3">
                                                                { leaderBoardList[2].avatar ? 
                                                                <img className="mauserlead" src={leaderBoardList[2].avatar} alt="" referrerPolicy={'no-referrer'} />
                                                                :
                                                                <span className='mauserlead letters'>
                                                                {leaderBoardList[2].name?.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                                                 </span>
                                                                 }
                                                                <div>
                                                                    <p className="rank"><img src={rank3} alt="" /></p>
                                                                    <p className='name'> {leaderBoardList[2].name} </p>
                                                                    <p className='email'> {leaderBoardList[2].email ?? leaderBoardList[2].uid} </p>
                                                                    <hr />
                                                                    <p className='gname'>{leaderBoardList[2].group}</p>
                                                                    <p className='errors'><span>Errors : {leaderBoardList[2].averageErrors.all} </span> <span className='ps-3'>Time: {leaderBoardList[2].averageTime.all.average.humanReadable} </span></p>
                                                                </div>
                                                            </div>
                                                            : null}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                          
                        </div>
                        <div className="row justify-content-center">
                        <div className="table-responsive workflowtb stickyhead " style={{ width:"98%" }}>
                            <table className="table table-hover leaderboardtable">
                                <thead>
                                    <tr>
                                        <th>Rank</th>
                                        <th>Name</th>
                                        <th>Email/UID</th>
                                        <th>Group</th>
                                        <th>Time Taken</th>
                                        <th>Errors</th>
                                    </tr>
                                </thead>
                                <tbody>

                                    {leaderBoardList.map((e, i) => {
                                        if (i < 3) return null;
                                        return (
                                            <tr  >
                                                <td> {e.rank} </td>
                                                <td>
                                                    <div className='d-flex'>
                                                        { e.avatar ? 
                                                        <img className="tableusricon" src={e.avatar} alt="" referrerPolicy={'no-referrer'} /> 
                                                        :
                                                        <span className='tableusricon letters'>
                                                        {e.name.split(' ').map(word => word[0]).slice(0, 2).join('')}
                                                        </span>
                                                        }
                                                        {e.name}
                                                    </div>
                                                </td>
                                                <td> {e.email ?? e.uid} </td>
                                                <td> {e.group} </td>
                                                <td> {e.averageTime.all.average.humanReadable} </td>
                                                <td> {e.averageErrors.all} </td>
                                            </tr>
                                        )
                                    })}

                                </tbody>
                            </table>
                        </div>
                        </div>
                    </div>
                    </div>
                    :
                    <div className="d-flex h-100 w-100 align-items-center justify-content-center">
                                    <NoLeaderboard />
                    </div>
                }
            </div>
        </div>
        </>
    )
}

export default Leaderboard
